import "./POIWidget.scss";
import moment from "moment";
import axios from "axios";
const env = require(`@/environments/${process.env.VUE_APP_ENV_PATH}`);
import POIWidgetEdit from "@/components/POI/POIWidgetEdit/POIWidgetEdit.vue";
import POIWidgetPreview from "@/components/POI/POIWidgetPreview/POIWidgetPreview.vue";
import { getTokenHeader } from "@/helpers/commonHelper";
import { getUserById } from "@/helpers/userHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";
import { uploadFile } from "@/helpers/fileHelper";
import { createError } from "@/helpers/newsHelper";

import _ from "lodash";
import XLSX from "xlsx";

const defaultItem = {
  apiKey: "",
  login: "",
  password: "",
  title: "",
  externalId: "",
  address: {
    address: "",
    additionalAddress: "",
    zip: "",
    city: "",
    district: "",
    country: "",
    phoneNumber: "",
    mobileNumber: "",
    eMail: "",
    website: ""
  },
  geo: {},
  filter: {
    include: {
      featureGroups: [],
      features: [],
      categoryTypes: [],
      categories: []
    },
    exclude: {
      featureGroups: [],
      features: [],
      categoryTypes: [],
      categories: [],
      pois: []
    }
  },
  allowedURLs: [],
  output: {
    colors: {
      manualColor: false,
      baseColor: "",
      lightColor: "",
      darkColor: "",
      hlLightColor: "",
      hlDarkColor: ""
    },
    initialView: "",
    possibleViews: [],
    emphasizedFeature: "",
    features: []
  },
  annotations: {},
  myPois: [],
  personalPicture: "",
  principal: ""
};

export default {
  data: () => ({
    headers: [
      {
        text: "Titel",
        align: "start",
        value: "title"
      },
      { text: "Login", value: "login" },
      { text: "Ort", value: "address.city" },
      { text: "Zuletzt geändert", value: "updatedAt" },
      { text: "Aktionen", value: "actions", sortable: false }
    ],
    pageCount: 0,
    page: 1,
    itemsPerPage: 10,
    options: {},
    dialog: false,
    widgetStatistics: [],
    search: "",
    editedItem: { ...defaultItem },
    moment,
    previewItem: {},
    showPreviewDialog: false,
    isLoading: false
  }),
  async mounted() {
    try {
      await this.fetchData();
      await this.getStatistic();
    } catch (error) {
      this.createError(error);
    }
  },
  computed: {
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    },
    exportConfigs() {
      return this.$store.state.exportConfigs;
    },
    total() {
      return this.$store.state.exportConfigsTotal;
    }
  },
  methods: {
    async nextPage() {
      const total = this.total || 0;
      const totalPages = Math.ceil(total / this.itemsPerPage);
      if (this.page < totalPages) {
        this.page++;
        await this.fetchData(false);
      }
    },
    async previousPage() {
      if (this.page > 1) {
        this.page--;
        await this.fetchData(false);
      }
    },
    editItem(item) {
      if (item)
        this.editedItem = _.assign(
          _.cloneDeep({ ...defaultItem }),
          _.cloneDeep({ ...item })
        );
      else this.editedItem = _.cloneDeep({ ...defaultItem });
      this.dialog = true;
    },
    async deleteItem(id) {
      const confirmRes = await this.$confirm(
        `Wollen Sie dieses Widget wirklich löschen?`,
        confirmWarningConfig
      );
      if (confirmRes) {
        try {
          const headers = getTokenHeader();
          const res = await axios.delete(
            `${env.poi_api_client_url}exportConfig/${id}`,
            {
              headers
            }
          );
          if (res.status === 200) {
            this.createSuccess("Widget wurde erfolgreich gelöscht");
            await this.fetchData();
          } else {
            this.createError(
              new Error("Request failed with statusCode: " + res.status)
            );
          }
        } catch (error) {
          this.createError(error);
        }
      }
    },

    createError(error) {
      this.$store.dispatch("createError", error);
    },
    createSuccess(message) {
      this.$store.dispatch("createSuccess", message);
    },
    async fetchData(ignoreSearchLength) {
      const params = {
        $skip: this.itemsPerPage * (this.page - 1),
        $limit: this.itemsPerPage,
        [`$sort[${this.options.sortBy?.[0] ?? "sortTitle"}]`]: this.options
          .sortDesc?.[0]
          ? -1
          : 1
      };
      if (ignoreSearchLength || (this.search && this.search.length >= 3))
        params.$search = this.search;
      else delete params.$search;
      await this.$store.dispatch("getExportConfigs", params);
    },
    async save(closeDialog) {
      try {
        await this.uploadPersonalImage();
        await this.uploadPoiImages();
        this.prepareEditedItem();
        if (this.editedItem._id) await this.updateWidget(getTokenHeader());
        else await this.createWidget(getTokenHeader());

        this.dialog = !closeDialog;
      } catch (error) {
        await this.$store.dispatch("createError", error.message);
      }
    },
    cancel() {
      this.dialog = false;
    },
    openPreview(item) {
      this.showPreviewDialog = true;
      this.previewItem = item;
    },
    closePreview() {
      this.showPreviewDialog = false;
      this.previewItem = {};
    },
    async uploadPoiImages() {
      await this.editedItem.myPois.asyncForEach(async poi => {
        if (
          poi.picture &&
          typeof poi.picture === "object" &&
          !Array.isArray(poi.picture)
        ) {
          const res = await uploadFile(
            poi.picture,
            this.editedItem.id || this.editedItem._id,
            "pois",
            this.editedItem.principal
          );
          poi.picture = res.url;
        }
      });
    },
    prepareEditedItem() {
      if (!this.editedItem.principal)
        this.editedItem.principal = this.selectedPrincipal.id;

      // If property exists, but value is empty
      // if it is implicit undefined, nothing happens on delete
      if (!this.editedItem?.output?.emphasizedFeature)
        delete this.editedItem?.output?.emphasizedFeature;

      if (!this.editedItem?.output?.initialView)
        delete this.editedItem?.output?.initialView;
    },

    async uploadPersonalImage() {
      if (
        this.editedItem.personalPicture &&
        typeof this.editedItem.personalPicture === "object" &&
        !Array.isArray(this.editedItem.personalPicture)
      ) {
        const res = await uploadFile(
          this.editedItem.personalPicture,
          this.editedItem.id || this.editedItem._id,
          "pois",
          this.editedItem.principal
        );
        this.editedItem.personalPicture = res.url;
      }
    },
    async updateWidget(headers) {
      const res = await axios.put(
        `${env.poi_api_client_url}exportConfig/${this.editedItem._id}`,
        this.editedItem,
        { headers }
      );
      if (res.status === 200) {
        await this.$store.dispatch(
          "createSuccess",
          "Erfolgreich aktualisiert!"
        );
        await this.fetchData();
      }
    },
    async createWidget(headers) {
      const res = await axios.post(
        `${env.poi_api_client_url}exportConfig/`,
        this.editedItem,
        { headers }
      );
      if (res.status === 200 || res.status === 201) {
        await this.$store.dispatch("createSuccess", "Erfolgreich angelegt!");
        await this.fetchData();
        this.editedItem._id = res.data._id;
        this.editedItem.apiKey = res.data.apiKey;
      }
    },
    async displayUserName() {
      await this.widgetStatistics.asyncForEach(async statistic => {
        const user = await getUserById(statistic.triggeredBy);
        statistic.triggeredBy = `${user.first_name} ${user.last_name}`;
      });
    },
    async getStatistic() {
      try {
        const headers = getTokenHeader();
        const { data } = await axios.get(
          `${env.poi_api_client_url}widgetUser`,
          {
            headers
          }
        );
        this.widgetStatistics = data.data;
        await this.displayUserName();
      } catch (error) {
        await this.createError(error);
      }
    },
    async createStatistic() {
      this.isLoading = true;
      try {
        const headers = getTokenHeader();
        await axios.post(
          `${env.poi_api_client_url}widgetUser`,
          {},
          { headers }
        );
        await this.getStatistic();
      } catch (error) {
        this.createError(error);
      } finally {
        this.isLoading = false;
      }
    },
    exportXlsx(downloadAll, index) {
      if (!downloadAll) this.downloadList("xlsx", index);
      else this.downloadAllLists("xlsx");
    },

    downloadList(type, index) {
      const TABLE_TITLE_LINE = ["URL", "Erstellt von", "Datum"];
      const table = [TABLE_TITLE_LINE];
      table.push([
        [],
        this.widgetStatistics[index].triggeredBy,
        moment(this.widgetStatistics[index].createdAt).format(
          "DD.MM.YYYY HH:mm"
        )
      ]);
      this.widgetStatistics[index].urls.forEach(url => {
        table.push([url]);
      });
      const ws = XLSX.utils.aoa_to_sheet(table);
      const workbook = XLSX.utils.book_new();
      XLSX.utils.book_append_sheet(workbook, ws, `Widget Statistik`);
      XLSX.writeFile(workbook, `widgetStatistik.${type}`);
    },

    downloadAllLists(type) {
      const TABLE_TITLE_LINE = ["URL", "Erstellt von", "URL", "_id"];
      const table = [TABLE_TITLE_LINE];
      const workbook = XLSX.utils.book_new();
      this.widgetStatistics.forEach(statistic => {
        table.push([
          [],
          statistic.triggeredBy,
          statistic.createdAt,
          statistic._id
        ]);
        statistic.urls.forEach(url => {
          table.push([url]);
        });
        const ws = XLSX.utils.aoa_to_sheet(table);
        XLSX.utils.book_append_sheet(workbook, ws, `Widget Statistik`);
      });

      XLSX.writeFile(workbook, `widgetStatistik.${type}`);
    }
  },
  watch: {
    async options() {
      await this.fetchData();
    },
    async search() {
      await this.fetchData();
    }
  },
  components: { POIWidgetEdit, POIWidgetPreview, createError }
};
